import * as React from 'react';
import {PropsWithChildren} from "react";
import {AppNavBar} from "./AppNavBar";

interface Props {

}

export function MobilePage(props: PropsWithChildren<Props>) {
    return <div style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
    }}>
        <AppNavBar/>

        <div style={{
            padding: 16,
        }}>
            {props.children}
        </div>
    </div>;
}